import { render, staticRenderFns } from "./sam_actions.vue?vue&type=template&id=2224f359"
import script from "./sam_actions.vue?vue&type=script&lang=js"
export * from "./sam_actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports